<mat-drawer-container class="sidenav-container">
  <mat-drawer
    #drawer
    class="sidenav bg-light"
    color="text-white"
    fixedInViewport="true"
    style="width: 150px; overflow: hidden"
    [attr.role]="(isHandset$ | async) ? 'dialog' : 'navigation'"
    [mode]="(isHandset$ | async) ? 'over' : 'side'"
    [opened]="user ? false : true"
  >
    <div class="d-flex justify-content-center p-3" style="height: 70px">
      <div class="position-relative mx-0">
        <up-env-badge [env]="env"></up-env-badge>
      </div>
      <!-- <img *ngIf="user.tenantId == 1" src="/assets/images/vuptech-color.svg" style="height: 42px; width: auto;"> -->
      <img
        src="/assets/images/pointer_light.svg"
        style="height: 60px; width: auto"
      />
    </div>

    <!-- <div *ngIf="user.tenant" class="d-flex justify-content-center align-items-center mt-2 mb-1">
    <span class="h5">{{user?.tenant?.nome}}</span>
  </div> -->

    <div #menusList style="overflow-x: hidden; overflow-y: hidden">
      @if (user) {
        <mat-nav-list class="d-flex justify-content-between flex-column h-100">
          <div>
            @for (menu of menus; track menu) {
              <a
                mat-list-item
                [routerLink]="[menu.url]"
                [routerLinkActiveOptions]="{ exact: true }"
                routerLinkActive="active"
              >
                <div class="d-flex align-items-center">
                  <mat-icon class="me-2">{{ menu.icon }}</mat-icon>
                  <span>
                    {{ menu.title }}
                  </span>
                </div>
                @if (menu.showDivider) {
                  <mat-divider [inset]="true"></mat-divider>
                }
              </a>
            }
          </div>
          <div>
            @if (user) {
              <div
                mat-list-item
                class="px-3"
                matTooltip="{{ user?.name }}"
                [matTooltipPosition]="'above'"
              >
                <div class="d-flex align-items-center">
                  @if (user.image) {
                    <span class="me-2">
                      @if (user.image) {
                        <img
                          onStock
                          [src]="user.image"
                          [ngStyle]="sharedStyle"
                          style="
                            object-fit: cover;
                            border-radius: 50%;
                            width: 36px;
                            height: 36px;
                          "
                        />
                      }
                    </span>
                  }
                  @if (!user.image) {
                    <mat-icon class="me-2">account_circle</mat-icon>
                  }
                  <div
                    style="
                      width: 200x;
                      white-space: nowrap;
                      overflow: hidden;
                      text-overflow: ellipsis;
                    "
                  >
                    {{ user?.name }}
                  </div>
                </div>
              </div>
            }
          </div>
        </mat-nav-list>
      }
    </div>
  </mat-drawer>

  <mat-drawer-content>
    <div [class.container-fluid]="!hideContainer">
      <up-help-button [isValorUpDomain]="isValorUp"></up-help-button>

      <router-outlet></router-outlet>
    </div>
  </mat-drawer-content>
</mat-drawer-container>
